<template>
    <div id="lodingOverlay" v-show="loading === true">
        <div id="lodingBox" v-show="loading === true">
            <img :src="loadingImg"/>
        </div>
        <p class="lodingMessage">{{lodingShowMessage}}</p>
    </div>
</template>

<script>
import componentScrollControl from '../../js/modules/componentScrollControl.js'

export default {
    name: 'Parts',
    data() {
        return {
            loading: true,
            // ウィンドウのサイズを保持するために使用
            height: window.innerHeight,
        }
    },
    props:{
        lodingHiddenId: {
            type: String
        },
        lodingShowMessage: {
            type: String
        },
    },
    methods: {
        loading_start() {
            this.loading = true;
            this.$nextTick(function () {
                componentScrollControl.no_scroll();
                document.getElementById('page_top').style.display = 'none';
                if (this.lodingHiddenId.length !== 0 && document.getElementById(this.lodingHiddenId) !== null) {
                    document.getElementById(this.lodingHiddenId).style.visibility = "hidden";
                }
            })
        },
        loading_finish() {
            this.loading = false;
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
                if (this.lodingShowMessage !== 'mainBlock') {
                    componentScrollControl.return_scroll();
                    if (this.lodingHiddenId.length !== 0 && document.getElementById(this.lodingHiddenId) !== null) {
                        document.getElementById(this.lodingHiddenId).style.visibility = "visible";
                    }
                }
            })
        },
        handleResize: function() {
            this.$nextTick(function () {
                this.height = window.innerHeight;
                document.getElementById("lodingBox").style.top = this.height / 2 + "px";
                var loginMessage = document.getElementsByClassName("lodingMessage");
                for(var i = 0; i < loginMessage.length; i++){
                    loginMessage[i].style.top = (this.height / 2 + 100) + "px";
                }
            })
        },
    },
    computed: {
        /**********************************************************/
        // IEとそれ以外のブラウザによって表示するロゴを切り替える
        /**********************************************************/
        loadingImg() {
            var logo = '';
            var userAgent = window.navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('trident') != -1) {
                logo = require('../../assets/images/loader.gif');
            } else {
                logo = require('../../assets/images/loader.png');
            }
            return logo;
        },
    },
    mounted: function () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
}
</script>

<style lang="scss" scoped>
@import url(../../assets/css/parts/LoadingBoxForApp.css);
</style>